import { Anchor, Box } from '@zillow/constellation-10';
import LogoDesktop from './LogoDesktop';

const HeaderNavigationLogo = ({
  // true renders zillow rentals logo
  // false renders zillow logo
  altLogo,
  to,
}: {
  altLogo: boolean;
  to: string;
}) => (
  <Box
    css={
      altLogo
        ? {
            '& svg': { maxWidth: '100%', height: 'auto' },
            width: '50%',
          }
        : {
            position: 'relative',
            '& svg': { color: 'icon.accent.brand.hero' },
            height: '1100',
            width: '148px',
          }
    }
  >
    <Anchor
      href={to}
      aria-label="zillow rental manager home page"
      css={altLogo ? undefined : { position: 'absolute', width: '100%', height: '100%' }}
    >
      <LogoDesktop alternate={altLogo} />
    </Anchor>
  </Box>
);

export default HeaderNavigationLogo;
